// extracted by mini-css-extract-plugin
export var chevronIcon = "_b8-2";
export var teamName = "_b8-1";
export var teamSwitcherButton = "_b8-0";